import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format minutes into human-readable duration.
 * Examples:
 * - 45 → "45 minutes"
 * - 90 → "1 hour 30 minutes"
 * - 120 → "2 hours"
 * - 463 → "7 hours 43 minutes"
 */
export function formatDuration(totalMinutes: number | undefined | null): string {
  if (totalMinutes === undefined || totalMinutes === null || totalMinutes < 0) {
    return '0 minutes';
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.round(totalMinutes % 60);

  if (hours === 0) {
    return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  }

  if (minutes === 0) {
    return `${hours} hour${hours !== 1 ? 's' : ''}`;
  }

  return `${hours} hour${hours !== 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
}

/**
 * Format decimal hours into human-readable duration.
 * Examples:
 * - 4.9 → "4 hours 54 minutes"
 * - 1.5 → "1 hour 30 minutes"
 * - 8.0 → "8 hours"
 */
export function formatHoursDuration(hours: number | undefined | null): string {
  if (hours === undefined || hours === null || hours < 0) {
    return '0 minutes';
  }

  const totalMinutes = Math.round(hours * 60);
  return formatDuration(totalMinutes);
}
